import React from 'react';
import './Btn5.css';
import btnImg from '../../asserts/bb1.png';
import { useMusic } from '../layout/MusicContext';

const Btn5 = ({ label, onClick }) => {
  const { playClick } = useMusic();
  const handleClick = (e) => {
    playClick();
    if (onClick) onClick(e);
  };
  return (
    <button className="btn5" onClick={handleClick}>
      <img className="btn5-bg" src={btnImg} alt="" />
      <span className="btn5-text">{label}</span>
    </button>
  );
};

export default Btn5;